import BCModal from '../BCModal';
import Styles from './assets/styles.scss';
import IModalFrameProps from './entitites/IModalFrameProps';

const BCModalFrame = (props: IModalFrameProps) => {
	const handleCancel = () => {
		props.handleCancel?.();
	};

	const handleAfterClose = () => {
		props.afterClose?.();
	};

	return (
		<BCModal
			footer={null}
			key={props.key}
			visible={props.visible}
			loading={props.loading}
			title={null}
			className={Styles.ModalFrameContainer}
			width={props.width}
			zIndex={100}
			afterClose={handleAfterClose}
			handleCancel={handleCancel}
		>
			<iframe
				src={props.url}
				width="100%"
				frameBorder="0"
				height="100%"
			></iframe>
		</BCModal>
	);
};
export default BCModalFrame;
export { IModalFrameProps };
